export class BitBoardEntity {
    public static magic:number = 0x077cb531;
    public static MultiplyDeBruijnBitPosition:Array<number> = 
    [
      0, 1, 28, 2, 29, 14, 24, 3, 30, 22, 20, 15, 25, 17, 4, 8, 
      31, 27, 13, 23, 21, 19, 16, 7, 26, 12, 18, 6, 11, 5, 10, 9
    ];

    public static bitScanForwardDeBruijn32( b:number) :number{
        let r:number = BitBoardEntity.MultiplyDeBruijnBitPosition[((b & -b) * BitBoardEntity.magic) >>> 27];
        return r;
    }
    
    public static numberOfTrailingZeros( board:number ):number{
        let oldBoard:number = board;
        board &= board - 1;
        var position:number = oldBoard ^ board;
        var pos:number = BitBoardEntity.bitScanForwardDeBruijn32(position);
        return pos;
    }
    
            
    
    // [ higbits, lowbits ]
    private lowEntity:number;
    private highEntity:number;
    
    constructor( low:number, high:number) 
    {
        this.lowEntity = low;
        this.highEntity = high;
    }
    
    //TODO
    public toArray():Array<number> { 
        let arr:Array<number> = new Array();
        var i:number = 0;
        this.actionOnPawns( function( position:number ):void { 
            arr[ i++ ] = position;
        } );
        return arr; 
    }
    
    public hasIntersection( other:BitBoardEntity ):Boolean{
        return ((other.lowEntity & this.lowEntity) != 0) || ((other.highEntity & this.highEntity) != 0);
    }
    
    public add( val:BitBoardEntity ):BitBoardEntity {
        this.lowEntity |= val.lowEntity;
        this.highEntity |= val.highEntity;
        return this;
    }
    
    public notInPlace():BitBoardEntity {
        this.lowEntity = ~this.lowEntity;
        this.highEntity = ~this.highEntity;
        return this;
    }
    
    public addBits( low:number, high:number ):void{
        this.lowEntity |= low;
        this.highEntity |= high;
    }
    
    public setPosition( position:number ):void{
        if ( position < 32 ) {
            this.lowEntity |= 1 << position;
        }else {
            this.highEntity |= 1 << (position - 32);
        }
    }
    
    public unsetPosition( position:number ):void{
        if ( position < 32 ) {
            this.lowEntity &= ~(1 << position);
        }else {
            this.highEntity &= ~(1 << (position - 32) );
        }
    }
    
    public isPositionSet( position:number ):boolean{
        if( position < 32 ){
            return (this.lowEntity & ( 1 << position)) == ( 1 << position);
        }else {
            return (this.highEntity & ( 1 << ( position - 32 ))) == ( 1 << (position - 32 ));
        }
    }
    
    public isPositionFree( position:number ):boolean {
        if( position < 32 ){
            return (this.lowEntity & ( 1 << position)) == 0;
        }else {
            return (this.highEntity & ( 1 << position)) == 0;
        }
    }
    
    public clone( ):BitBoardEntity{
        return new BitBoardEntity( this.lowEntity, this.highEntity );
    }
    
    public static countStaticPawns( board:number ):number {
        let count:number = 0;
        for ( ; board != 0; count++ ) {
            board &= board - 1;
        }
        return count;
    }
    
    public countPawns():number{
        return BitBoardEntity.countStaticPawns(this.lowEntity) + BitBoardEntity.countStaticPawns(this.highEntity);
    }
    
    public static actionOnPawnsStatic( board:number, action:Function, add:number ):void {
        let count:number = 0;
        for ( ; board != 0; count++ ) {
            var oldBoard:number = board;
            board &= board - 1;
            var position:number = oldBoard ^ board;
            action(BitBoardEntity.bitScanForwardDeBruijn32(position) + add);
        }
    }
    
    public actionOnPawns( action:Function ):void {
        BitBoardEntity.actionOnPawnsStatic( this.lowEntity, action, 0) ;
        BitBoardEntity.actionOnPawnsStatic( this.highEntity, action, 32 ) ;
    }
}